import { Fragment, h } from "preact"
import { TableComponent } from "../../../../table/styled"

export const TableData = ({ columns, data }: any) => {
  return <TableComponent
    style={{ textAlign: "center" }}
    columns={columns}
    dataSource={data}
    bordered
    size="middle"
    scroll={{ x: 'max-content', y: 200 }}
  />
}